import { LabReportUploadRequest } from "@9amhealth/openapi";
import { NineButton, NineHeading } from "@9amhealth/wcl/generated/react";
import { FC } from "react";
import Translate from "src/ui/components/Translate/Translate";
import { ChatUploadLabResultsCubit, Step } from "../ChatUploadLabResultsCubit";
import { useBlocNext } from "@blac/react";
import { PlanIcon } from "src/constants/icons";
import {
  HelpLinkButton,
  HelpLinkWrap,
  InfoText,
  StepContent,
  SupportActions
} from "../components";

interface HowToGetReportScreenProps {
  isUploading: boolean;
  uploadFilesAndShowStep: (
    step: Step,
    provider: LabReportUploadRequest["provider"]
  ) => Promise<void>;
}

export const HowToGetReportScreen: FC<HowToGetReportScreenProps> = ({
  uploadFilesAndShowStep,
  isUploading
}) => {
  const [, { setCurrentStep }] = useBlocNext(ChatUploadLabResultsCubit);

  const handleBackToUpload = () => {
    setCurrentStep("upload");
  };

  const handleAskForSupport = () => {
    void uploadFilesAndShowStep("willHelpYou", undefined);
  };

  return (
    <StepContent>
      <NineHeading>
        <PlanIcon />
        <h3 className="as-h4-large">
          <Translate msg="chat.labUpload.howToGetReport.title" />
        </h3>
      </NineHeading>
      <InfoText>
        <Translate msg="chat.labUpload.howToGetReport.description" />
      </InfoText>
      <SupportActions>
        <NineButton
          onClick={handleBackToUpload}
          disabled={isUploading ? "true" : "false"}
        >
          <Translate msg="chat.labUpload.howToGetReport.back" />
        </NineButton>
      </SupportActions>
      <HelpLinkWrap>
        <div>
          <Translate msg="chat.labUpload.howToGetReport.cantReach" />
        </div>
        <HelpLinkButton type="button" onClick={handleAskForSupport}>
          <Translate msg="chat.labUpload.howToGetReport.askForSupport" />
        </HelpLinkButton>
      </HelpLinkWrap>
    </StepContent>
  );
};
